import { render, staticRenderFns } from "./StarshopAccountDiscrepancy.vue?vue&type=template&id=db8c0d0e&scoped=true"
import script from "./StarshopAccountDiscrepancy.vue?vue&type=script&lang=js"
export * from "./StarshopAccountDiscrepancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8c0d0e",
  null
  
)

export default component.exports